import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GeneralService } from 'src/app/service/general.service';
import { GetListBase } from './client-parent.model';
import { map } from 'rxjs/operators';

@Injectable()

export class clienttserivce extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService, public ngxservice: NgxUiLoaderService) {
    super();
  }

  public execute(state: GetListBase): void {
    this.getList(state).subscribe(x => super.next(x));
  }

  getList(state?: GetListBase): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Client/GetClients", state)
      .pipe(map(
        (response: any) => (<any>{

          count: response['count'],
          result: response['result']

        }))).pipe(map((e: any) => {
          e.result.forEach(element => {

            element.phone2 = (element.phone2 != null && element.phone2 != "") ? this.general.reconverPhoneGoogleLibhttpsave(element.phone2) : null;
            element.phone1 = (element.phone1 != null && element.phone1 != "") ? this.general.reconverPhoneGoogleLibhttpsave(element.phone1) : null;
            element.isMNChoiceAssessment=(element.isMNChoiceAssessment==true)?"Yes":"No";
            //  element.isMAEligible = (element.isMAEligible ==true) ? 'Yes' : 'No'
            //   element.spendDown = (element.spendDown ==true) ? 'Yes' : 'No'
            element.isMAEligible = (element.isMAEligible ==true) ? 'Yes' : (element.isMAEligible == null)? null :'No'
            element.spendDown = (element.spendDown ==true) ? 'Yes' : (element.spendDown == null) ? null : 'No'

          })
          return e;
        })
        )
  }
  // ......................................relationship tax percenet.............................................................//
  public executetax(state: GetListBase): void {
    this.getrelationtaxpercentlist(state).subscribe(x => super.next(x));
  }

  getrelationtaxpercentlist(state?: GetListBase): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ClientRelationshipTax/GetEmployerEmpRelTaxPercent", state)
      .pipe(map(
        (response: any) => (<any>{

          count: response['count'],
          result: response['result']
        }))

      )
  }


}
